import React, { useState, useEffect } from "react";
import signinLogo from "../../assets/images/login/signin-logo.png";
import "./Signup.css";
import logo from "../../assets/images/login/Nathicharami Logo.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";
import Preloader from "../../Components/Loader/Loader";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const SignupSchema = object({
  first_name: string().required("First name is required"),
  last_name: string().required("Last name is required"),
  email: string().email("Enter a valid email").required("Email is required"),
  mobile_no: string()
    .required("Mobile number is required")
    .matches(/^[6-9]\d{9}$/, "Enter a valid mobile number"),
  pincode: string()
    .required("Pincode is required")
    .matches(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit pincode"),
  password: string().required("Password is required"),
});

const bankOptions = [
  "State Bank of India",
  "HDFC Bank",
  "ICICI Bank",
  "Axis Bank",
  "Punjab National Bank",
  "Bank of Baroda",
  "Canara Bank",
  "Union Bank of India",
  "IDBI Bank",
  "Indian Bank",
];

export function Signup() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile_no: "",
      pincode: "",
      password: "",
      user_type: "agent",
    },
    validationSchema: SignupSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      try {
        // Check if captcha is empty
        if (!userCaptcha || userCaptcha.trim() === "") {
          toast.error("Please enter the captcha");
          setIsLoading(false);
          return;
        }

        // Check if captcha matches
        if (userCaptcha !== captcha) {
          toast.error("Captcha does not match!");
          setIsLoading(false);
          return;
        }
        const response = await axiosInstance.post("/agent/signup/", values);

        if (response.data.status === "success") {
          setIsLoading(false);

          if (response.data.data?.token) {
            localStorage.setItem("temp_token", response.data.data.token);
          }
          localStorage.setItem("mobile_number", values.mobile_no);

          toast.success(response.data.message || "Registered Successfully!");
          resetForm();

          setTimeout(() => {
            navigate("/otp");
          }, 1000);
        } else {
          setIsLoading(false);
          toast.error(response.data.message || "Signup failed!");
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Signup failed:", error);

        // ✅ Check if backend sent a message
        const errorMsg =
          error.response?.data?.message || "Signup failed. Please try again.";

        setServerError(errorMsg);
        toast.error(errorMsg); // Show backend error message
      }
    },
  });

  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captchaText = "";
    for (let i = 0; i < 6; i++) {
      captchaText += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(captchaText);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <>
      {isLoading && <Preloader />}
      <ToastContainer />
      <div className="signin-container">
        <div className="signin-left">
          <div>
            <div className="signin-logo">
              <img src={signinLogo} alt="logo" />
            </div>
            <div className="signin-lefttext">
              Welcome to GoMak Referral Portal. Please register to continue You
              can earn upto 1000 to 2000 daily.
            </div>
          </div>
        </div>

        <div className="signin-right">
          <form
            className="signin-formContainers"
            onSubmit={formik.handleSubmit}
          >
            <div className="signin-title">Sign Up</div>
            <div className="signin-subtitle">Welcome to GoMak Referral</div>

            {/* Two-column layout */}
            <div className="form-grid">
              {/* First Name */}
              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span> First Name
                </label>
                <input
                  type="text"
                  placeholder="Enter first name"
                  name="first_name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.first_name && formik.errors.first_name
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <div className="error-message-signIn">
                    {formik.errors.first_name}
                  </div>
                )}
              </div>

              {/* Last Name */}
              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span> Last Name
                </label>
                <input
                  type="text"
                  placeholder="Enter last name"
                  name="last_name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.last_name && formik.errors.last_name
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <div className="error-message-signIn">
                    {formik.errors.last_name}
                  </div>
                )}
              </div>

              {/* Email */}
              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span> Email
                </label>
                <input
                  type="text"
                  placeholder="Enter email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.email && formik.errors.email
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="error-message-signIn">
                    {formik.errors.email}
                  </div>
                )}
              </div>

              {/* Mobile Number */}
              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span> Mobile Number
                </label>
                <input
                  type="tel"
                  placeholder="Enter mobile number"
                  maxLength={10}
                  name="mobile_no"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  value={formik.values.mobile_no}
                  // onChange={formik.handleChange}
                  onChange={(e) => {
                    // Allow only digits and limit to 10
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    formik.setFieldValue("mobile_no", value);
                  }}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.mobile_no && formik.errors.mobile_no
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.mobile_no && formik.errors.mobile_no && (
                  <div className="error-message-signIn">
                    {formik.errors.mobile_no}
                  </div>
                )}
              </div>

              {/* Pincode */}
              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span> Pincode
                </label>
                <input
                  type="text"
                  placeholder="Enter pincode"
                  name="pincode"
                  value={formik.values.pincode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.pincode && formik.errors.pincode
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.pincode && formik.errors.pincode && (
                  <div className="error-message-signIn">
                    {formik.errors.pincode}
                  </div>
                )}
              </div>

              {/* Password */}
              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span> Password
                </label>
                <div className="password-input-wrapper">
                  {" "}
                  <input
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Enter password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.password && formik.errors.password
                        ? "input-error-signIn"
                        : ""
                    }
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setPasswordVisible((prev) => !prev)}
                  >
                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                {formik.touched.password && formik.errors.password && (
                  <div className="error-message-signIn">
                    {formik.errors.password}
                  </div>
                )}
              </div>

              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span> Captcha
                </label>
                <div className="captcha-container">
                  <div className="captcha-text">{captcha}</div>
                  <button
                    type="button"
                    className="refresh-captcha"
                    onClick={generateCaptcha}
                  >
                    &#10227;
                  </button>
                </div>
                <input
                  type="text"
                  placeholder="Enter captcha"
                  value={userCaptcha}
                  onChange={(e) => setUserCaptcha(e.target.value)}
                  className="captcha-input"
                />
              </div>
            </div>

            {serverError && (
              <div className="error-message-signIn">{serverError}</div>
            )}

            <div className="btnLogin">
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Signing up..." : "Sign Up"}
              </button>
            </div>

            <div className="forgot-text">
              Already have an account?{" "}
              <Link to="/login" className="register-link">
                Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
